import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle
} from '@headlessui/react';

import { PrimaryButton, SecondaryButton } from '../components/buttons/Buttons';
import { Row } from "../components/Flex";
import SelectField from '../components/SelectField';
import { PackageFile, Portal } from '../typings';
import { fetchFiles } from "../package-api";
import { ApiContextType } from "../api-context";
import MultiSelectField from "../components/MultiSelectField";
import { toast } from "react-toastify";

interface Props {
    currentFiles: PackageFile[];
    api: ApiContextType;
    portals: Portal[];
    open: boolean;
    onClose: () => void;
    onAdd: (files: PackageFile[]) => void;
}

function AddFilesDialog({ open, onClose, portals, api, currentFiles, onAdd }: Props) {
    const [portalId, setPortalId] = useState<number>();
    const [files, setFiles] = useState<number[]>([]);
    const [orgFiles, setOrgFiles] = useState<PackageFile[]>([]);

    useEffect(() => {
        console.log(portalId);
        if (portalId) {
            const currentFileIds = currentFiles.map(c => c.id);
            fetchFiles(api, portalId)
                .then(files => setOrgFiles(files
                    .sort((a,b) => a.name.localeCompare(b.name))
                    .filter(f => !currentFileIds.includes(f.id))))
                .catch(() => toast.error("Failed to fetch files"));
        }
    }, [portalId]);

    const onConfirm = () => {
        onAdd(orgFiles.filter(f => files.includes(f.id)).map(f => ({ ...f, duration: 10 })));
        setPortalId(undefined);
        setFiles([]);
        setOrgFiles([]);
    };

    return (
        <Dialog open={open} as="div" onClose={onClose} className="dialog-container">
            <DialogBackdrop className="dialog-backdrop"/>
            <div className="dialog">
                <DialogPanel className="dialog-box">
                    <DialogTitle as="div" className="dialog-title">
                        Add files to package
                    </DialogTitle>
                    <SelectField
                        label="Portal"
                        placeholder="Select portal"
                        value={portalId}
                        options={portals.map(item => ({ value: item.id, text: item.name }))}
                        setValue={setPortalId}
                    />
                    <MultiSelectField
                        hasSearch={true}
                        label="Files"
                        placeholder="Select files"
                        value={files}
                        options={orgFiles.map(item => ({ value: item.id, text: item.name }))}
                        setValue={setFiles}
                    />
                    <Row gap={8} style={{ justifyContent: 'flex-end', marginTop: '8px' }}>
                        <PrimaryButton label="Add" onClick={onConfirm} disabled={false} />
                        <SecondaryButton label="Cancel" onClick={onClose} />
                    </Row>
                </DialogPanel>
            </div>
        </Dialog>
    );
}

export default AddFilesDialog;
